import React, { useState, useEffect } from 'react';
import './OfflineIndicator.css';

/**
 * Offline Indicator Component
 * Shows a banner when the app goes offline
 */
function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBanner(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline || !showBanner) {
    return null;
  }

  return (
    <div className="offline-indicator">
      <div className="offline-content">
        <svg className="offline-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path 
            d="M3 9a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 5M3 9v5m0-5h5" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M21 15a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 19m18-4v-5m0 5h-5" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
        <div className="offline-text">
          <strong>Modo Offline</strong>
          <span>Você está trabalhando offline. Algumas funcionalidades podem estar limitadas.</span>
        </div>
      </div>
    </div>
  );
}

export default OfflineIndicator;
